import Link from "next/link";
import { portalRoutes } from "@nju/routes";
import { A, Panel, Separator, Text } from "@nju/ui";

export function CancellationNotPossible() {
  return (
    <Panel>
      <div className="flex items-center flex-col">
        <Text
          align="center"
          size={{
            "@onlyMobile": "xl",
            "@fromTablet": "keyM",
          }}
          weight="bold"
        >
          nie możesz anulować
        </Text>
        <Text
          align="center"
          size={{
            "@onlyMobile": "xl",
            "@fromTablet": "keyM",
          }}
          weight="bold"
        >
          przeniesienia numeru
        </Text>
        <Separator size="xs" tone="invisible" />
        <div className="flex justify-center">
          <img alt="Informacje o cookies" src="/images/portout-fail.svg" />
        </div>
        <Separator size="xs" tone="invisible" />
        <Text
          align="center"
          size={{
            "@onlyMobile": "m",
            "@fromTablet": "l",
          }}
        >
          Przeniesienie numeru
        </Text>
        <Text
          align="center"
          size={{
            "@onlyMobile": "m",
            "@fromTablet": "l",
          }}
        >
          nie może zostać anulowane.
        </Text>
        <Separator size="s" tone="invisible" />
      </div>
      <div className="flex flex-col from-tablet:flex-row justify-center">
        <Link
          href={portalRoutes.mojeKonto.index.get({ mode: "mobile" })}
          passHref={true}
        >
          <A
            size={{
              "@onlyMobile": "s",
            }}
          >
            wróć na start
          </A>
        </Link>
      </div>
    </Panel>
  );
}
